document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll("#resources-grid .resource-card");

  const searchInput = document.getElementById("resource-search");
  const typeFilter = document.getElementById("resource-type-filter");
  const categoryFilter = document.getElementById("resource-category-filter");

  function normalize(value) {
    return (value || "").toString().trim().toLowerCase();
  }

  function normalizeType(value) {
    const type = normalize(value);

    if (["jpg", "jpeg", "png", "webp"].includes(type)) return "image";
    if (type === "pdf") return "pdf";
    if (["mp3", "wav", "audio"].includes(type)) return "audio";

    return type;
  }

  function getTypeLabel(type) {
    if (type === "image") return "Image";
    if (type === "pdf") return "PDF";
    if (type === "audio") return "Audio";
    return type.toUpperCase();
  }

  function fillTypeFilter() {
    if (!typeFilter) return;

    const types = new Set();

    cards.forEach((card) => {
      const type = normalizeType(card.dataset.type);
      if (type) types.add(type);
    });

    typeFilter.innerHTML = '<option value="">All types</option>';

    [...types].sort().forEach((type) => {
      const option = document.createElement("option");
      option.value = type;
      option.textContent = getTypeLabel(type);
      typeFilter.appendChild(option);
    });
  }

  function fillCategoryFilter() {
    if (!categoryFilter) return;

    const categories = new Set();

    cards.forEach((card) => {
      const category = (card.dataset.category || "").trim();
      if (category) categories.add(category);
    });

    categoryFilter.innerHTML = '<option value="">All categories</option>';

    [...categories]
      .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
      .forEach((category) => {
        const option = document.createElement("option");
       option.value = category;
        option.textContent = category;
        categoryFilter.appendChild(option);
      });
  }

  function filterCards() {
    const searchValue = normalize(searchInput?.value);
    const typeValue = normalize(typeFilter?.value);
    const categoryValue = normalize(categoryFilter?.value);

    cards.forEach((card) => {
      const title = normalize(card.dataset.title);
      const book = normalize(card.dataset.book);
      const type = normalizeType(card.dataset.type);
      const category = normalize(card.dataset.category);
      const desc = normalize(card.dataset.desc);

      const matchesSearch =
        !searchValue ||
        title.includes(searchValue) ||
        book.includes(searchValue) ||
        desc.includes(searchValue);

      const matchesType = !typeValue || type === typeValue;
      const matchesCategory = !categoryValue || category === categoryValue;

      card.style.display =
        matchesSearch && matchesType && matchesCategory ? "" : "none";
    });

    document
      .querySelectorAll(".resources-category-heading")
      .forEach(function (heading) {
        let sibling = heading.nextElementSibling;
        let anyVisible = false;
        while (
          sibling &&
          !sibling.classList.contains("resources-category-heading")
        ) {
          if (
            sibling.classList.contains("resource-card") &&
            sibling.style.display !== "none"
          ) {
            anyVisible = true;
            break;
          }
          sibling = sibling.nextElementSibling;
        }
        heading.style.display = anyVisible ? "" : "none";
      });
  }

  searchInput?.addEventListener("input", filterCards);
  typeFilter?.addEventListener("change", filterCards);
  	categoryFilter?.addEventListener("change", filterCards);

  fillTypeFilter();
  fillCategoryFilter();

  function extensionFromUrl(url) {
    try {
      const pathname = new URL(url, window.location.origin).pathname;
      const match = pathname.match(/\.([a-z0-9]{2,5})$/i);
      return match ? match[1].toLowerCase() : "";
    } catch (e) {
      return "";
    }
  }

  function shouldForceDownload(card) {
    if (!card) return false;
    const type = normalizeType(card.dataset.type);
    if (type === "image" || type === "pdf") return true;
    const url = (card.dataset.url || "").toLowerCase();
    return /\.(jpe?g|png|webp|gif|pdf)(\?|#|$)/i.test(url);
  }

  function buildDownloadFilename(title, url, type) {
    const base =
      (title || "resource")
        .trim()
        .toLowerCase()
        .replace(/[^\w\s-]/g, "")
        .replace(/[\s_]+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "")
        .slice(0, 80) || "resource";

    let ext = extensionFromUrl(url);
    if (!ext) {
      const normalized = normalizeType(type);
      if (normalized === "image") ext = "jpg";
      else if (normalized === "pdf") ext = "pdf";
      else if (normalized === "audio") ext = "mp3";
    }
    if (ext === "jpeg") ext = "jpg";
    return ext ? base + "." + ext : base;
  }

  function triggerFileDownload(url, filename, linkEl) {
    if (linkEl) {
      linkEl.classList.add("is-downloading");
      linkEl.setAttribute("aria-busy", "true");
    }

    function finish() {
      if (!linkEl) return;
      linkEl.classList.remove("is-downloading");
      linkEl.removeAttribute("aria-busy");
    }

    function saveBlob(blob) {
      const blobUrl = URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = blobUrl;
      anchor.download = filename;
      anchor.rel = "noopener";
      anchor.style.display = "none";
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      window.setTimeout(function () {
        URL.revokeObjectURL(blobUrl);
      }, 1000);
      finish();
    }

    return fetch(url, { mode: "cors", credentials: "omit" })
      .then(function (res) {
        if (!res.ok) throw new Error("Download failed");
        return res.blob();
      })
      .then(saveBlob)
      .catch(function () {
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = filename;
        anchor.rel = "noopener noreferrer";
        anchor.style.display = "none";
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        finish();
      });
  }

  const resourcesGrid = document.getElementById("resources-grid");
  if (resourcesGrid) {
    resourcesGrid.addEventListener("click", function (e) {
      const btn = e.target.closest("a.resource-btn--download");
      if (!btn || !resourcesGrid.contains(btn) || btn.classList.contains("resource-btn--gated"))
        return;

      const card = btn.closest(".resource-card");
      if (!card || !shouldForceDownload(card)) return;

      const url = (card.dataset.url || btn.getAttribute("href") || "").trim();
      if (!url || url === "#") return;

      e.preventDefault();
      const filename = buildDownloadFilename(card.dataset.title, url, card.dataset.type);
      triggerFileDownload(url, filename, btn);
    });
  }

  const resourcesRoot = document.getElementById("resources-page");
  if (!resourcesRoot || resourcesRoot.dataset.resourcesUnlock !== "true") {
    return;
  }

  const Mc = window.McSignupForm;
  if (!Mc) {
    console.warn(
      "mailchimp-form-helpers.js missing; resources unlock validation disabled",
    );
  }

  const storageKey = resourcesRoot.dataset.unlockStorageKey;
  const unlockedLabel = resourcesRoot.dataset.unlockedButtonLabel || "Download";
  const modal = document.getElementById("resources-unlock-modal");
  const form = document.getElementById("resources-unlock-form");
  const emailInput = document.getElementById("resources-unlock-email");

  if (!storageKey || !modal || !form) {
    return;
  }

  if (Mc) {
    Mc.bindClearOnInput(form);
  }

  function persistUnlocked() {
    try {
      localStorage.setItem(storageKey, "1");
    } catch (e) {
      /* ignore quota / private mode */
    }
  }

  function isUnlocked() {
    try {
      return localStorage.getItem(storageKey) === "1";
    } catch (e) {
      return false;
    }
  }

  function applyUnlockedUi() {
    resourcesRoot.classList.add("resources-page--unlocked");
    resourcesRoot
      .querySelectorAll(".resource-btn--gated")
      .forEach(function (btn) {
        const card = btn.closest(".resource-card");
        const url = card && card.dataset.url;
        if (!url) return;
        btn.classList.remove("resource-btn--gated");
        btn.removeAttribute("role");
        btn.setAttribute("href", url);
        const unlockedType = normalizeType(card.dataset.type);
        if (unlockedType === "audio" || unlockedType === "link") {
          btn.setAttribute("target", "_blank");
        } else {
          btn.removeAttribute("target");
        }
        btn.setAttribute("rel", "noopener noreferrer");
        const labelEl = btn.querySelector(".resource-btn__label");
        if (labelEl) {
          labelEl.textContent = unlockedLabel;
        }
      });
  }

  function openModal() {
    if (Mc) Mc.clearErrors(form);
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    setTimeout(function () {
      emailInput?.focus();
    }, 50);
  }

  function closeModal() {
    if (form.classList.contains("is-submitting")) return;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  if (isUnlocked()) {
    applyUnlockedUi();
  } else {
    resourcesRoot.addEventListener("click", function (e) {
      const btn = e.target.closest(".resource-btn--gated");
      if (!btn || !resourcesRoot.contains(btn)) return;
      e.preventDefault();
      openModal();
    });
  }

  modal
    .querySelectorAll("[data-resources-unlock-close]")
    .forEach(function (el) {
      el.addEventListener("click", function () {
        if (form.classList.contains("is-submitting")) return;
        closeModal();
      });
    });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.classList.contains("is-open")) {
      if (form.classList.contains("is-submitting")) return;
      closeModal();
    }
  });

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    let formOk = true;
    if (Mc) {
      formOk = Mc.validate(form);
    } else if (!form.checkValidity()) {
      form.reportValidity();
      formOk = false;
    }
    if (!formOk) {
      const firstBad = form.querySelector(':invalid, [aria-invalid="true"]');
      if (firstBad && typeof firstBad.focus === "function") firstBad.focus();
      return;
    }

    const submitBtn = form.querySelector('button[type="submit"]');
    if (Mc) {
      Mc.setLoading(form, true, submitBtn);
    } else {
      submitBtn.dataset.mcFallbackOriginal = submitBtn.textContent.trim();
      submitBtn.disabled = true;
      submitBtn.setAttribute("aria-busy", "true");
      submitBtn.classList.add("is-loading");
      form.classList.add("is-submitting");
      submitBtn.textContent = submitBtn.dataset.loadingText || "Submitting…";
    }

    let finalized = false;
    let iframe = null;

    function finalize() {
      if (finalized) return;
      finalized = true;
      clearTimeout(doneTimer);
      if (Mc) {
        Mc.setLoading(form, false, submitBtn);
      } else {
        submitBtn.disabled = false;
        submitBtn.removeAttribute("aria-busy");
        submitBtn.classList.remove("is-loading");
        form.classList.remove("is-submitting");
        if (submitBtn.dataset.mcFallbackOriginal !== undefined) {
          submitBtn.textContent = submitBtn.dataset.mcFallbackOriginal;
          delete submitBtn.dataset.mcFallbackOriginal;
        }
      }
      persistUnlocked();
      applyUnlockedUi();
      closeModal();
      form.removeAttribute("target");
      form.reset();
      if (iframe && iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
    }

    iframe = document.createElement("iframe");
    iframe.setAttribute("title", "Newsletter signup");
    iframe.name = "resources-mailchimp-" + String(Date.now());
    iframe.setAttribute(
      "style",
      "position:absolute;width:0;height:0;border:0;left:-9999px;top:0;visibility:hidden",
    );
    document.body.appendChild(iframe);
    form.setAttribute("target", iframe.name);

    const doneTimer = setTimeout(finalize, 2000);

    if (
      typeof HTMLFormElement !== "undefined" &&
      HTMLFormElement.prototype.submit
    ) {
      HTMLFormElement.prototype.submit.call(form);
    } else {
      form.submit();
    }
  });
});
